import { render } from "./paymentLinkRedirections.vue?vue&type=template&id=db743306"
import script from "./paymentLinkRedirections.vue?vue&type=script&lang=js"
export * from "./paymentLinkRedirections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__